<div>
  <kl-publish-robocall-form
    (robocallCreated)="onRobocallSent($event)"
  ></kl-publish-robocall-form>
</div>
